import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';

const loadLottie = require('bundle-loader?lazy&name=[name]!lottie-web');

const LANDSCAPE = 'landscape';
const PORTRAIT = 'portrait';

export default el => {
    const dom = $(el);
    const anims = { portrait: null, landscape: null };
    const elements = { portrait: dom.find('[data-portrait]'), landscape: dom.find('[data-landscape]') };

    let lottie = null;
    let orientation = null;
    let observer = null;

    const getOrientation = () => (Viewport.width > Viewport.height ? LANDSCAPE : PORTRAIT);

    const loadOrPlay = o => {
        const animation = anims[o];
        const element = elements[o];
        if (animation) {
            animation.play();
        } else {
            element.css('opacity', 0);
            anims[o] = lottie.loadAnimation({
                container: element.get(0),
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: element.data('lottie')
            });
            anims[o].addEventListener('DOMLoaded', () => {
                element.find('svg > g').attr('clip-path', null);
                element.css('opacity', 1);
            });
        }
        if (element) {
            element.attr('hidden', null);
        }
    };

    const stopAndHide = o => {
        const animation = anims[o];
        const element = elements[o];
        if (animation) {
            animation.pause();
        }
        if (element) {
            element.attr('hidden', '');
        }
    };

    const onIntersectionChange = entries => {
        const animation = anims[getOrientation()];
        if (animation) {
            if (entries.filter(entry => entry.isIntersecting).length) {
                animation.play();
            } else {
                animation.pause();
            }
        }
    };

    const update = () => {
        const o = getOrientation();
        if (orientation !== o) {
            orientation = o;
            loadOrPlay(orientation);
            stopAndHide(orientation === PORTRAIT ? LANDSCAPE : PORTRAIT);
        }
    };

    const init = () => {
        loadLottie(l => {
            lottie = l;
            Viewport.on('resize', update);
            observer = new IntersectionObserver(onIntersectionChange);
            observer.observe(el);
            update();
        });
    };

    const destroy = () => {
        Viewport.off('resize', update);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/LottieHero.js